"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemToastSelector = exports.selectedSiteOptionSelector = exports.systemToBeEditedSelector = exports.isEditSystemModalOpenSelector = exports.isAddSystemModalOpenSelector = exports.saveSystemErrorMessage = exports.saveSystemSuccessMessage = exports.isSavingSystemSelector = exports.areSystemsLoadingSelector = exports.systemsSelector = void 0;
const systemsSelector = (state) => {
    return state.systems.systems;
};
exports.systemsSelector = systemsSelector;
const areSystemsLoadingSelector = (state) => {
    return state.systems.areSystemsLoading;
};
exports.areSystemsLoadingSelector = areSystemsLoadingSelector;
const isSavingSystemSelector = (state) => {
    return state.systems.isSavingSystem;
};
exports.isSavingSystemSelector = isSavingSystemSelector;
const saveSystemSuccessMessage = (state) => {
    return state.systems.saveSystemSuccessMessage;
};
exports.saveSystemSuccessMessage = saveSystemSuccessMessage;
const saveSystemErrorMessage = (state) => {
    return state.systems.saveSystemErrorMessage;
};
exports.saveSystemErrorMessage = saveSystemErrorMessage;
const isAddSystemModalOpenSelector = (state) => {
    return state.systems.isAddSystemModalOpen;
};
exports.isAddSystemModalOpenSelector = isAddSystemModalOpenSelector;
const isEditSystemModalOpenSelector = (state) => {
    return state.systems.isEditSystemModalOpen;
};
exports.isEditSystemModalOpenSelector = isEditSystemModalOpenSelector;
const systemToBeEditedSelector = (state) => {
    return state.systems.systemToBeEdited;
};
exports.systemToBeEditedSelector = systemToBeEditedSelector;
const selectedSiteOptionSelector = (state) => {
    return state.systems.selectedSiteOption;
};
exports.selectedSiteOptionSelector = selectedSiteOptionSelector;
const systemToastSelector = (state) => {
    return state.systems.systemToast;
};
exports.systemToastSelector = systemToastSelector;
